export interface PromotionDates {
  startDate: Date;
  endDate: Date;
}

export function fixOrtography(text: string): string {
  const replacements: Record<string, string> = {
    credito: "crédito",
    Credito: "Crédito",
    Electronico: "Electrónico",
    electronico: "electrónico",
  };

  return Object.entries(replacements).reduce(
    (acc, [key, value]) => acc.replace(new RegExp(key, "g"), value),
    text
  );
}

// Estado global de promociones
export let currentPromotion = {
  isActive: false,
  name: "",
  dates: { startDate: new Date(), endDate: new Date() },
  legend: "",
};

function parseDBDate(dateStr: string): Date {
  // Convierte "2026-04-06 00:00:00.0" a Date válido
  return new Date(dateStr.replace(' ', 'T').replace(/\.\d+$/, ''));
}

export function setPromotionStatus(
  isActive: boolean,
  promotionName?: string,
  fechaInicio?: string,
  fechaFin?: string
): void {
  currentPromotion.isActive = isActive;
  esBuenFin = currentPromotion.isActive;

  if (isActive && promotionName) {
    currentPromotion.name = promotionName;

    if (fechaInicio && fechaFin) {
      currentPromotion.dates = {
        startDate: parseDBDate(fechaInicio),
        endDate: parseDBDate(fechaFin),
      };
    }

    currentPromotion.legend = generatePromotionLegend(
      currentPromotion.name,
      currentPromotion.dates
    );
    leyendaBuenfin = currentPromotion.legend;
    console.log("🚀 Promoción activa:", currentPromotion);
  }
}

export function generatePromotionLegend(
  name: string,
  dates: PromotionDates
): string {
  // Para Buen Fin, mostrar fechas específicas del 13 al 17 de Noviembre
  // if (name === "Buen Fin") {
  //   return `Promoción ${name}, vigencia del 13 al 17 de noviembre del 2025.`;
  // }

  const startDay = dates.startDate.getDate();
  const endDay = dates.endDate.getDate();
  const startMonth = dates.startDate.getMonth();
  const endMonth = dates.endDate.getMonth();
  const year = dates.endDate.getFullYear();

  const monthName = dates.startDate.toLocaleDateString("es-MX", { month: "long" });

  // Si están en el mismo mes, usar formato corto
  if (startMonth === endMonth) {
    // return `Promoción ${name}, vigencia del ${startDay} al ${endDay} de ${monthName} del ${year}.`;
    return `Promoción ${name}.`;
  }

  // Si están en meses diferentes, mostrar ambos meses
  const endMonthName = dates.endDate.toLocaleDateString("es-MX", { month: "long" });
  // return `Promoción ${name}, vigencia del ${startDay} de ${monthName} al ${endDay} de ${endMonthName} del ${year}.`;
  return `Promoción ${name}.`;
}

export function promotionDate(stringDate: string): PromotionDates {
  // Intenta primero el formato: "13 de Noviembre al 17 de Noviembre"
  let dateMatch = stringDate.match(
    /(\d{1,2}) de (\w+) al (\d{1,2}) de (\w+)/i
  );

  let startDay: string, startMonth: string, endDay: string, endMonth: string;
  let yearStr: string | undefined;

  if (dateMatch) {
    // Formato: "13 de Noviembre al 17 de Noviembre"
    [, startDay, startMonth, endDay, endMonth] = dateMatch;
  } else {
    // Intenta el formato: "13 al 17 de Noviembre" (con o sin año)
    dateMatch = stringDate.match(
      /(\d{1,2}) al (\d{1,2}) de (\w+)(?: (?:del )?(\d{4}))?/i
    );

    if (dateMatch) {
      // Formato: "13 al 17 de Noviembre" o "13 al 17 de Noviembre 2025"
      [, startDay, endDay, endMonth, yearStr] = dateMatch;
      startMonth = endMonth; // Ambos días están en el mismo mes
    } else {
      throw new Error("Formato de fecha no reconocido");
    }
  }

  const months: Record<string, number> = {
    enero: 0,
    febrero: 1,
    marzo: 2,
    abril: 3,
    mayo: 4,
    junio: 5,
    julio: 6,
    agosto: 7,
    septiembre: 8,
    octubre: 9,
    noviembre: 10,
    diciembre: 11,
  };

  const currentYear = yearStr ? parseInt(yearStr) : new Date().getFullYear();
  const startDate = new Date(
    currentYear,
    months[startMonth.toLowerCase()],
    parseInt(startDay)
  );
  const endDate = new Date(
    currentYear,
    months[endMonth.toLowerCase()],
    parseInt(endDay)
  );

  if (isNaN(startDate.getTime())) throw new Error("Fecha de inicio inválida");
  if (isNaN(endDate.getTime())) throw new Error("Fecha de fin inválida");

  return { startDate, endDate };
}

export function getPromotionName(fullString: string): string {
  if (!fullString.includes(":")) {
    throw new Error('Formato de promoción inválido: falta el separador ":"');
  }
  return fullString.split(":")[0].trim();
}

export function isDateInPromotion(
  dateToCheck: Date | string,
  promotionDates: PromotionDates
): boolean {
  const checkDate =
    typeof dateToCheck === "string" ? new Date(dateToCheck) : dateToCheck;
  const { startDate, endDate } = promotionDates;

  // Normalizar todas las fechas a medianoche para comparación de días completos
  const check = new Date(checkDate);
  check.setHours(0, 0, 0, 0);

  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);

  const end = new Date(endDate);
  end.setHours(23, 59, 59, 999);

  console.log('🔍 Verificando fecha en promoción:');
  console.log('  Fecha a verificar:', check);
  console.log('  Inicio promoción:', start);
  console.log('  Fin promoción:', end);
  console.log('  ¿Está en rango?:', check >= start && check <= end);

  return check >= start && check <= end;
}

// Mantener compatibilidad con código legacy
export let leyendaBuenfin = currentPromotion.legend;
export let esBuenFin = currentPromotion.isActive;

// tools/tools.ts

// ... (otras importaciones y código existente)

export function esCotizacionBuenFin(fechaCotizacion: string): boolean {
  // Mantenemos compatibilidad con el sistema antiguo
  const fechaInicioBf = new Date(2023, 10, 16); // 16 de Noviembre 2023
  const fechaC = new Date(fechaCotizacion);

  // Aseguramos comparación correcta de fechas
  fechaC.setHours(0, 0, 0, 0);
  fechaInicioBf.setHours(0, 0, 0, 0);

  // Si hay una promoción activa, usamos esas fechas
  if (currentPromotion.isActive) {
    return isDateInPromotion(fechaC, currentPromotion.dates);
  }

  // Fallback al comportamiento original
  return fechaC.getTime() >= fechaInicioBf.getTime();
}

export function esCotizacionHotSale(fechaCotizacion: string): boolean {
  const fecha = new Date(fechaCotizacion);

  // Si hay una promoción activa, usamos esas fechas
  if (currentPromotion.isActive) {
    return isDateInPromotion(fecha, currentPromotion.dates);
  }

  // Comportamiento original como fallback
  const fechaInicioBf = new Date(2025, 4, 26); // 26 de Mayo 2025
  const fechaFinBf = new Date(2025, 5, 3); // 3 de Junio 2025

  // Ajuste de horas para comparación
  fechaInicioBf.setHours(0, 0, 0, 0);
  fechaFinBf.setHours(23, 59, 59, 999);

  return (
    fecha.getTime() >= fechaInicioBf.getTime() &&
    fecha.getTime() <= fechaFinBf.getTime()
  );
}

export function textMonth(dateStr: string): string {
  switch (dateStr.split("/")[1]) {
    case "05":
      return "Mayo";
    case "06":
      return "Junio";
    case "07":
      return "Julio";
    case "08":
      return "Agosto";
    case "09":
      return "Septiembre";
  }
}
